import { CreditCard } from '../../components/icons/CreditCard'
import { High } from '../../components/icons/High'
import { Home } from '../../components/icons/Home'
import { Invoice } from '../../components/icons/Invoice'
import { QuestionMark } from '../../components/icons/QuestionMark'
import { User } from '../../components/icons/User'
import { MenuItem } from './types'

export const getAdminMenu = (t: (key: string) => string): MenuItem[] => [
  { name: t('common.navigation.overview'), path: '/admin', icon: Home },
  { name: t('common.navigation.services'), path: '/admin/services', icon: Invoice },
  { name: t('common.navigation.statistics'), path: '/admin/statistics', icon: High },
  { name: t('common.navigation.employees'), path: '/admin/employees', icon: User },
  { name: t('common.navigation.billing'), path: '/admin/billing', icon: CreditCard },
  { name: t('common.navigation.support'), path: '/admin/support', icon: QuestionMark },
]
